import React from 'react';
import styles from './TagsLayout.css';
import { clsx } from 'clsx';

interface ITagsLayoutProps {
  isSearchpage: boolean;
}

export const TagsLayout: React.FC<React.PropsWithChildren<ITagsLayoutProps>> = ({ isSearchpage, children }) => {
  return (
    <div className={clsx(styles['container'], isSearchpage && styles['search-page'])} data-testid="Tags">
      {children}
    </div>
  );
};
